import { findNode } from "@convertkit/slate-react"

const usesCustomDnd = block => block.type === "captioned-image"

export default () => {
  return {
    onDrop(event, editor, next) {
      const document = editor.value.document
      const droppedNodeKey = event.dataTransfer.getData("text")
      const droppedNode = document.findDescendant(
        descendant => descendant.key === droppedNodeKey
      )

      if (droppedNode && usesCustomDnd(droppedNode)) {
        const targetNode = findNode(event.target, editor)
        const targetNodeIndex = document.nodes.findIndex(
          node => node.key === targetNode.key
        )

        event.preventDefault()
        editor.moveNodeByKey(droppedNode.key, document.key, targetNodeIndex - 1)
        return false
      }

      next()
    },
    onDragStart(event, editor, next) {
      const slateNode = findNode(event.target, editor)
      if (slateNode && usesCustomDnd(slateNode)) {
        event.dataTransfer.setData("text", slateNode.key)
      }
      next()
    }
  }
}
